
import { useState } from 'react';
import { depoimentosComunidade } from '../../../mocks/comunidade';

const MuralComunidade = () => {
  const [likes, setLikes] = useState<Record<number, boolean>>({});
  const [likeCounts, setLikeCounts] = useState<Record<number, number>>(
    depoimentosComunidade.reduce((acc, d) => ({ ...acc, [d.id]: d.likes }), {} as Record<number, number>)
  );

  const handleLike = (id: number) => {
    setLikes((prev) => ({ ...prev, [id]: !prev[id] }));
    setLikeCounts((prev) => ({
      ...prev,
      [id]: likes[id] ? prev[id] - 1 : prev[id] + 1,
    }));
  };

  return (
    <section className="bg-luxury-black py-28 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
      <div className="absolute top-40 left-20 w-72 h-72 bg-gold-500/5 rounded-full blur-[120px]"></div>
      <div className="absolute bottom-40 right-20 w-56 h-56 bg-gold-500/5 rounded-full blur-[100px]"></div>

      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        <div className="flex items-center justify-center gap-4 mb-4">
          <div className="w-12 h-px bg-gold-500/40"></div>
          <span className="font-['Montserrat'] text-xs tracking-[0.3em] uppercase text-gold-400">
            Inspiração
          </span>
          <div className="w-12 h-px bg-gold-500/40"></div>
        </div>

        <h2 className="font-['Playfair_Display'] text-4xl lg:text-5xl text-center text-white mb-4">
          Mural da Comunidade
        </h2>
        <p className="font-['Montserrat'] text-sm text-white/35 text-center max-w-lg mx-auto mb-16 font-light tracking-wide">
          Trechos de cartas compartilhados por membros que quiseram inspirar outros a escreverem também
        </p>

        <div className="max-w-6xl mx-auto">
          {/* Primeira linha - 3 cards */}
          <div className="grid md:grid-cols-3 gap-5 mb-5">
            {depoimentosComunidade.slice(0, 3).map((item) => (
              <div
                key={item.id}
                className="bg-white/[0.04] backdrop-blur-sm border border-gold-500/10 rounded-2xl p-7 hover:border-gold-500/25 transition-all duration-500 group"
              >
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-11 h-11 rounded-full overflow-hidden border-2 border-gold-500/25 flex-shrink-0">
                    <img
                      src={item.avatar}
                      alt={item.nome}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h4 className="font-['Playfair_Display'] font-semibold text-sm text-white">
                      {item.nome}
                    </h4>
                    <p className="font-['Montserrat'] text-[10px] text-white/30 tracking-wide">
                      {item.cidade}
                    </p>
                  </div>
                  {item.plano === 'premium' && (
                    <div className="ml-auto">
                      <div className="w-6 h-6 rounded-full bg-gold-500/15 flex items-center justify-center">
                        <i className="ri-vip-crown-2-fill text-gold-500 text-xs"></i>
                      </div>
                    </div>
                  )}
                </div>

                <div className="mb-5">
                  <i className="ri-double-quotes-l text-gold-500/20 text-2xl"></i>
                </div>

                <p className="font-['Montserrat'] text-sm text-white/50 leading-relaxed font-light italic mb-6">
                  {item.trecho}
                </p>

                <div className="flex items-center justify-between">
                  <span className="font-['Montserrat'] text-[10px] text-white/20 tracking-wide">
                    {item.data}
                  </span>
                  <button
                    onClick={() => handleLike(item.id)}
                    className="flex items-center gap-1.5 cursor-pointer group/like"
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i
                        className={`${
                          likes[item.id] ? 'ri-heart-fill text-rose-400' : 'ri-heart-line text-white/25 group-hover/like:text-rose-400'
                        } text-sm transition-colors duration-300`}
                      ></i>
                    </div>
                    <span className={`font-['Montserrat'] text-xs ${likes[item.id] ? 'text-rose-400' : 'text-white/25'} transition-colors`}>
                      {likeCounts[item.id]}
                    </span>
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Segunda linha - 2 cards maiores */}
          <div className="grid md:grid-cols-2 gap-5 mb-5">
            {depoimentosComunidade.slice(3, 5).map((item) => (
              <div
                key={item.id}
                className="bg-white/[0.04] backdrop-blur-sm border border-gold-500/10 rounded-2xl p-7 hover:border-gold-500/25 transition-all duration-500 flex gap-6"
              >
                <div className="w-20 h-20 rounded-xl overflow-hidden border-2 border-gold-500/20 flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.nome}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="font-['Playfair_Display'] font-semibold text-sm text-white">
                      {item.nome}
                    </h4>
                    {item.plano === 'premium' && (
                      <div className="w-5 h-5 rounded-full bg-gold-500/15 flex items-center justify-center">
                        <i className="ri-vip-crown-2-fill text-gold-500 text-[10px]"></i>
                      </div>
                    )}
                  </div>
                  <p className="font-['Montserrat'] text-[10px] text-white/30 tracking-wide mb-4">
                    {item.cidade} · {item.data}
                  </p>
                  <p className="font-['Montserrat'] text-sm text-white/50 leading-relaxed font-light italic mb-4">
                    &ldquo;{item.trecho}&rdquo;
                  </p>
                  <button
                    onClick={() => handleLike(item.id)}
                    className="flex items-center gap-1.5 cursor-pointer group/like"
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i
                        className={`${
                          likes[item.id] ? 'ri-heart-fill text-rose-400' : 'ri-heart-line text-white/25 group-hover/like:text-rose-400'
                        } text-sm transition-colors duration-300`}
                      ></i>
                    </div>
                    <span className={`font-['Montserrat'] text-xs ${likes[item.id] ? 'text-rose-400' : 'text-white/25'} transition-colors`}>
                      {likeCounts[item.id]}
                    </span>
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Card destaque */}
          <div className="relative rounded-2xl overflow-hidden group">
            <img
              src="https://public.readdy.ai/ai/img_res/9d250db08e1dba03b6dc51311606539c.jpg"
              alt="Escrevendo carta com caneta dourada"
              className="w-full h-[280px] object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent"></div>
            <div className="absolute bottom-0 left-0 p-8 max-w-lg">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-gold-500/30 flex-shrink-0">
                  <img
                    src={depoimentosComunidade[5].avatar}
                    alt={depoimentosComunidade[5].nome}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h4 className="font-['Playfair_Display'] font-semibold text-sm text-white">
                    {depoimentosComunidade[5].nome}
                  </h4>
                  <p className="font-['Montserrat'] text-[10px] text-white/40 tracking-wide">
                    {depoimentosComunidade[5].cidade} · {depoimentosComunidade[5].data}
                  </p>
                </div>
              </div>
              <p className="font-['Montserrat'] text-sm text-white/65 leading-relaxed font-light italic">
                &ldquo;{depoimentosComunidade[5].trecho}&rdquo;
              </p>
            </div>
            <div className="absolute bottom-6 right-8">
              <button
                onClick={() => handleLike(depoimentosComunidade[5].id)}
                className="flex items-center gap-1.5 cursor-pointer group/like"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i
                    className={`${
                      likes[depoimentosComunidade[5].id]
                        ? 'ri-heart-fill text-rose-400'
                        : 'ri-heart-line text-white/40 group-hover/like:text-rose-400'
                    } text-sm transition-colors duration-300`}
                  ></i>
                </div>
                <span className={`font-['Montserrat'] text-xs ${likes[depoimentosComunidade[5].id] ? 'text-rose-400' : 'text-white/40'} transition-colors`}>
                  {likeCounts[depoimentosComunidade[5].id]}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MuralComunidade;
